import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  ThemeMode,
  Typography,
  useBreakpoints,
  useTheme,
} from '@monorepo/nova-ui';
import BalanceCredits from './balance-credits';
import BalanceDialogHeader from './balance-dialog-header';
import BalanceSwitchButton, {
  BalanceSwitchOption,
} from './balance-switch-button';
import BalanceTotalAvailable from './balance-total-available';
import BalanceTransactions from './balance-transactions';

const BalanceDialog = ({
  open,
  onClose,
  userId,
}: {
  open: boolean;
  onClose: () => void;
  userId?: string;
}) => {
  const { isMobile } = useBreakpoints();
  const theme = useTheme();
  const [selected, setSelected] = useState<BalanceSwitchOption>(
    BalanceSwitchOption.transactions,
  );
  const { t } = useTranslation('hubCommon');
  return (
    <Dialog
      open={open}
      onClose={onClose}
      variant="bare"
      maxWidth={false}
      fullWidth={isMobile}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor:
              theme.palette.mode === ThemeMode.LIGHT
                ? 'rgba(0, 0, 0, 0.4)'
                : 'rgba(255, 255, 255, 0.4)',
          },
        },
        paper: {
          sx: {
            borderRadius: theme.typography.pxToRem(44),
            margin: isMobile ? '0px' : theme.typography.pxToRem(32),
            width: isMobile ? '99vw' : 'auto',
            maxWidth: isMobile ? '99vw' : theme.typography.pxToRem(635),
          },
        },
      }}
    >
      <DialogContent
        sx={{
          padding: theme.typography.pxToRem(42),
          borderRadius: theme.typography.pxToRem(44),
          width: isMobile ? '100%' : theme.typography.pxToRem(635),
          backgroundColor: theme.palette.background.default,
        }}
      >
        <BalanceDialogHeader onClose={onClose} />
        <Typography
          variant="h2"
          fontSize={theme.typography.pxToRem(44)}
          fontWeight={theme.typography.fontWeightBold}
          marginBottom={theme.typography.pxToRem(24)}
        >
          {t('userCredit')}
        </Typography>
        <BalanceSwitchButton
          selectedOption={selected}
          onOptionChange={setSelected}
        />
        {selected === BalanceSwitchOption.transactions && (
          <BalanceTransactions userId={userId} />
        )}
        {selected === BalanceSwitchOption.availableCredit && (
          <BalanceCredits userId={userId} />
        )}
        <BalanceTotalAvailable userId={userId} />
      </DialogContent>
    </Dialog>
  );
};

export default BalanceDialog;
